export const aNamed = "a-named";
